import { combineReducers } from "@reduxjs/toolkit";
import { authenticationSlice } from "./slices/AuthenticationSlice";
import { signUpSlice } from "./slices/SignUpSlice";
import { productSlice } from "./slices/ProductSlice";
import { subscriptionSlice } from "./slices/SubscriptionSlice";
import { tokensSlice } from "./slices/TokenSlice";
import { invoiceSlice } from "./slices/InvoiceSlice";
import { dashboardSlice } from "./slices/DashboardSlice";
import { userSlice } from "./slices/UserSlice";
import { dropdownValuesSlice } from "./slices/DropdownValueSlice";
import { userManagementSlice } from "./slices/UserManagementSlice";
import { productManagementSlice } from "./slices/ProductManagementSlice";
import { productLicenseManagementSlice } from "./slices/ProductLicenseManagementSlice";
import { demoSlice } from "./slices/DemoSlice";
import { docsSlice } from "./slices/DocsSlice";
import { contactSalesSlice } from "./slices/ContactSalesSlice";

const appReducer = combineReducers({
  authData: authenticationSlice.reducer,
  signUpData: signUpSlice.reducer,
  productData: productSlice.reducer,
  subscriptionData: subscriptionSlice.reducer,
  tokenData: tokensSlice.reducer,
  invoiceData: invoiceSlice.reducer,
  dashboardData: dashboardSlice.reducer,
  userData: userSlice.reducer,
  dropDownData: dropdownValuesSlice.reducer,
  userManagementData: userManagementSlice.reducer,
  productManagementData: productManagementSlice.reducer,
  productLicenseManagementData: productLicenseManagementSlice.reducer,
  demoData: demoSlice.reducer,
  docsData: docsSlice.reducer,
  contactSalesData: contactSalesSlice.reducer
});

export const rootReducer: any = (state: RootStateType, action: any) => {
  // Reset state on logout
  if (action.type === "authentication/userLogout") {
    state = {} as RootStateType;
  }

  return appReducer(state, action);
};

export type RootStateType = ReturnType<typeof appReducer>;
